<template>
  <div class="w100 pl10 pr10 pt10 pb10 bg-w card-shadow cu-p app-card" v-loading="loading">
    <div class="flex-box al-c pb5 bor-b app-card-img" @click="clickItem">
      <img :src="data.serveImage ? data.serveImage : `${baseUrl}images/icon-app.png`" width="48" height="48">
      <p class="ml10 flex-1 ellipsis-2" style="font-size: 15px;">{{ data.serveName }}</p>
    </div>
    <div class="pt5 pl5 pr5 flex-box grey">
      <p class="flex-1 mr10 ellipsis">{{ data.deptName }}</p>
      <p>{{ data.favoriteCount }}人收藏</p>
    </div>
    <div class="pt5 pl5 pr5 flex-box al-c grey">
      <div class="flex-1 mr10">
        <i class="font-16 el-icon-star-on" :class="Number(i) <= data.appraise || data.serveType != 1 ? 'yellow' : 'grey2'" v-for="i in 5" :key="i"></i>
      </div>
      <i class="myfont font-20" :class="data.collection ? 'icon-xihuan1 red' : 'icon-iconfontxihuan'" @click.stop="changeCollect"></i>
    </div>
    <a ref="url" class="none" :href="url" target="_blank"></a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppCard",
  components: {},
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      url: "",
    };
  },
  computed: {
    ...mapGetters(["userToken"]),
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    changeCollect() {
      if (this.data.collection) {
        this.$http
          .delete("/personal/collection/delCo", {
            params: {
              serveId: this.data.id,
            },
          })
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.$message.success(data.resMsg);
              this.data.collection = !this.data.collection;
              this.data.favoriteCount--;
              this.$emit("change-collect");
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$http
          .post(
            "/personal/collection/newCo",
            this.$qs.stringify({ serveId: this.data.id })
          )
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.$message.success(data.resMsg);
              this.data.collection = !this.data.collection;
              this.data.favoriteCount++;
              this.$emit("change-collect");
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    clickItem() {
      switch (this.data.serveType) {
        case 0:
          this.$router.push({
            path: `/serveSearch/${this.data.id}/${this.data.interfaceUrl}`,
          });
          break;
        case 1:
          this.$router.push({
            path: `/serveApproval/${this.data.id}`,
          });
          break;
        case 2:
          this.$router.push({
            path: `/serveCustomized/${this.data.id}/${this.data.interfaceUrl}`,
          });
          break;
        case 9:
          this.$http
            .post(
              "/statistical/serverInsert",
              this.$qs.stringify({
                serviceId: this.data.id,
                appType: 9,
              })
            )
            .then(() => {})
            .catch(() => {});

          this.url = this.data.linkUrl;

          this.$nextTick(() => {
            this.$refs.url.click();
          });
          break;
        default:
          break;
      }
    },
  },
  watch: {},
  filters: {
    serveType(value) {
      switch (value) {
        case 0:
          return "查询类";
        case 1:
          return "审批类";
        case 9:
          return "外部连接";
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.app-card {
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.app-card:hover {
  background: #e9f6fa;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.grey2 {
  color: #ddd;
}
</style>
